// extracted by mini-css-extract-plugin
export default {"root":"FirstFormTabs_root__hi5VF","tabs":"FirstFormTabs_tabs__p+18y","btnWrapper":"FirstFormTabs_btnWrapper__jWa5b","btnFirstWrap":"FirstFormTabs_btnFirstWrap__FwaQ2"};